import React from 'react';
import { TextareaFieldProps } from './types';

const TextareaField: React.FC<TextareaFieldProps> = ({
  id,
  label,
  value,
  onChange,
  disabled = false,
  required = false,
  placeholder = ' ',
  onFocus,
  onBlur,
  hasValue,
  getFloatingLabelStyle,
  getFloatingInputStyle,
  styles,
  rows = 3,
}) => {
  return (
    <div style={styles.textareaContainer}>
      <textarea
        id={id}
        value={value || ''}
        onChange={onChange ? e => onChange(e.target.value) : undefined}
        disabled={disabled}
        onFocus={onFocus}
        onBlur={onBlur}
        style={getFloatingInputStyle(true, id)}
        placeholder={placeholder}
        rows={rows}
      />
      <label htmlFor={id} style={getFloatingLabelStyle(id, hasValue)}>
        {label}
        {required && <span style={{ color: 'red' }}>*</span>}
      </label>
    </div>
  );
};

export default React.memo(TextareaField);
